import { Card } from 'components/Card';
import React, { FC } from 'react';
import cx from 'clsx';
import styles from './ShimmerCard.module.scss';
import { SHIMMER_CARD } from './const';

type ShimmerCardProps = {
  showItemImage?: boolean;
  className?: string;
}

export const ShimmerCard: FC<ShimmerCardProps> = ({ showItemImage = false, className }) => (
  <Card aria-hidden className={cx(styles.card, className)} data-testid={SHIMMER_CARD.root} >
    <div className={styles.contentWrapper}>
      <div className={styles.header}>
        <h3 aria-hidden className="shimmer" />
        <p aria-hidden className="shimmer" />
      </div>
      <p aria-hidden className="shimmer" />
      <p aria-hidden className="shimmer" />
    </div>
    {showItemImage && <div aria-hidden className={cx(styles.itemImage, 'shimmer')} />}
  </Card>
);
